// CSS
import "./index.css";
import "./main.scss";

// Libraries
import FetchData from "./components/FetchData";

function App() {
  return (
    <>
      <FetchData />
    </>
  );
}

export default App;
